import { EntityModel } from '@/interfaces'
import {
  ALL_REDIRECTS_QUERY,
  CREATE_REDIRECT_MUTATION,
  DELETE_REDIRECT_MUTATION,
  FORCE_DELETE_REDIRECT_MUTATION,
  SINGLE_REDIRECT_QUERY,
  UPDATE_REDIRECT_MUTATION,
} from './graphql'
import cmsPageEntity from '@/entities/cmsPage/entity'
import travelEntity from '@/entities/travel/entity'

const redirectModel: EntityModel = {
  name: 'redirect',
  namePlural: 'redirects',
  uniqueName: 'redirect',
  uniqueNamePlural: 'redirects',
  path: 'config/tenant/redirect',
  baseUrl: '/config/tenant/redirects',
  translationPrefix: 'entities:redirect.',
  getDisplayName: (values: any) => {
    return 'URL Redirect'
  },
  gql: {
    getAll: ALL_REDIRECTS_QUERY,
    getSingle: SINGLE_REDIRECT_QUERY,
    create: CREATE_REDIRECT_MUTATION,
    update: UPDATE_REDIRECT_MUTATION,
    delete: DELETE_REDIRECT_MUTATION,
    forceDelete: FORCE_DELETE_REDIRECT_MUTATION,
  },
  attributes: {
    fromType: {
      name: 'fromType',
      label: 'entities:redirect.attributes.fromType.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'URL',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    fromUrl: {
      name: 'fromUrl',
      label: 'entities:redirect.attributes.fromUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    fromPage: {
      name: 'fromPage',
      label: 'entities:redirect.attributes.fromPage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    fromTravel: {
      name: 'fromTravel',
      label: 'entities:redirect.attributes.fromTravel.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    toType: {
      name: 'toType',
      label: 'entities:redirect.attributes.toType.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'URL',
      defaultInput: true,
      inputType: 'hidden',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    toUrl: {
      name: 'toUrl',
      label: 'entities:redirect.attributes.toUrl.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
    toPage: {
      name: 'toPage',
      label: 'entities:redirect.attributes.toPage.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsPageEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    toTravel: {
      name: 'toTravel',
      label: 'entities:redirect.attributes.toTravel.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return travelEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default redirectModel
